import { render, staticRenderFns } from "./otherReq.vue?vue&type=template&id=69d12fdf&scoped=true&lang=pug&"
import script from "./otherReq.vue?vue&type=script&lang=js&"
export * from "./otherReq.vue?vue&type=script&lang=js&"
import style0 from "./otherReq.vue?vue&type=style&index=0&id=69d12fdf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d12fdf",
  null
  
)

export default component.exports